import { render } from "./UploadBox.vue?vue&type=template&id=85c53b1e"
import script from "./UploadBox.vue?vue&type=script&lang=js"
export * from "./UploadBox.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "85c53b1e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('85c53b1e', script)) {
    api.reload('85c53b1e', script)
  }
  
  module.hot.accept("./UploadBox.vue?vue&type=template&id=85c53b1e", () => {
    api.rerender('85c53b1e', render)
  })

}

script.__file = "resources/js/Pages/Station/Partials/UploadBox.vue"

export default script